<div class="shop-working-time">
  <sd-icon class="icon-size-xs" [type]="iconTypes.HISTORY"></sd-icon>
  <span class="text-c1-m-300 text-lg-b3-s-300">{{ workingTime }}</span>
</div>
